/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { readSymbol as e } from "../../symbols.js";
import o from "../../core/Error.js";
import { isSome as s } from "../../core/maybe.js";
import r from "../Symbol3D.js";
import { to3D as n } from "./symbolConversion.js";
import t from "../WebStyleSymbol.js";

function m(e, o, s, r) {
  var n = i(e, {}, r);
  n && (o[s] = n);
}

function i(e, m, i) {
  if (!e) return null;

  if (i && "web-scene" === i.origin && !(e instanceof r) && !(e instanceof t)) {
    var _r = n(e, {
      retainCIM: !0
    });

    return s(_r.symbol) ? _r.symbol.write(m, i) : (i.messages && i.messages.push(new o("symbol:unsupported", "Symbols of type '".concat(e.declaredClass, "' are not supported in scenes. Use 3D symbology instead when working with WebScene and SceneView"), {
      symbol: e,
      context: i,
      error: _r.error
    })), null);
  }

  return i && "web-map" === i.origin && "web-style" === e.type ? (i.messages && i.messages.push(new o("symbol:unsupported", "Symbols of type '".concat(e.declaredClass, "' are not supported in webmaps. Use CIMSymbol instead when working with WebMap in MapView."), {
    symbol: e,
    context: i
  })), null) : e.write(m, i);
}

function l(o, s) {
  return e(o, null, s);
}

export { l as fromJSON, m as write };